<script lang="ts">
	import '../app.css';
	import { injectSpeedInsights } from '@vercel/speed-insights/sveltekit';
	import { browser } from '$app/environment';
	import { page } from '$app/stores';
	import { webVitals } from '$lib/vitals';
	import { invalidate } from '$app/navigation';
	import { onMount } from 'svelte';

	import { AppLayout, AppBar, ThemeSwitch, NavItem } from 'svelte-ux';

	import type { LayoutServerData } from './$types';

	export let data: LayoutServerData;

	injectSpeedInsights();

	$: if (browser && data?.analyticsId) {
		webVitals({
			path: $page.url.pathname,
			params: $page.params,
			analyticsId: data.analyticsId
		});
	}

	let { supabase, session } = data;
	$: ({ supabase, session } = data);

	let metaTitle = 'Todays Recipes';
	let metaDescription = 'Todays Recipes Website';

	$: metaTitle = $page.data?.metaTitle || metaTitle;
	$: metaDescription = $page.data?.metaDescription || metaDescription;

	let nav = [
		{
			text: 'Home',
			path: '/'
		},
		{
			text: 'All Recipes',
			path: '/recipes/search'
		},
		{
			text: 'Meal Planner',
			path: '/planner'
		}
	];

	$: if (session && nav.findIndex((element) => element.text === 'Edit') === -1) {
		nav = [
			...nav,
			{
				text: 'Edit',
				path: '/recipes/edit'
			},
			{
				text: 'AI Creation',
				path: '/recipes/random'
			},
			{
				text: 'Account',
				path: '/account'
			}
		];
	}

	onMount(() => {
		const { data } = supabase.auth.onAuthStateChange((event, _session) => {
			if (_session?.expires_at !== session?.expires_at) {
				invalidate('supabase:auth');
			}
		});

		return () => data.subscription.unsubscribe();
	});
</script>

<svelte:head>
	<title>{metaTitle}</title>
	<meta name="description" content={metaDescription} />
	<script async src="https://www.googletagmanager.com/gtag/js?id=G-B3KYVDYGSS"></script>
	<script>
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag('js', new Date());

		gtag('config', 'G-B3KYVDYGSS');
	</script>
</svelte:head>

<div class="app">
	<AppLayout>
		<svelte:fragment slot="nav">
			<!-- Nav menu -->
			<div class="h-full bg-surface-300 py-2">
				{#each nav as n}
					<NavItem
						text={n.text}
						currentUrl={$page.url}
						path={n.path}
						classes={{
							root: 'flex items-center text-sm text-surface-content/70 pl-6 py-2 hover:bg-surface-100/70 relative',
							active:
								'bg-primary/10 font-medium before:absolute before:bg-primary before:rounded-full before:w-1 before:h-2/3 before:left-[6px] shadow z-10'
						}}
					/>
				{/each}
			</div>
		</svelte:fragment>

		<AppBar head={false} class="flex bg-primary text-primary-content" title="Todays Recipe">
			<div slot="actions">
				<!-- App actions -->
				<ThemeSwitch />
			</div>
			<div class="w-3/4 text-right">AI integrated recipe design and meal planning</div>
		</AppBar>

		<main class="isolate p-5">
			<slot />
		</main>
	</AppLayout>
</div>
